<template>
  <div>
    <div class="m-6 pt-4" v-if="!cancel && data && data.status == 0 && data.check3Day == false">
      <div class="text-center">
          <h3 class="bold" v-if="!refusal">Duyệt đề xuất tăng ca</h3>
          <h3 class="bold" v-else>Từ chối đề xuất tăng ca</h3>
      </div>
      <div class="text-left d-flex justify-content-center col-md-12 pb-4">
        <div class="col-md-5 rounded bg-white pb-6">
          <div class="col-md-12 d-flex mt-5">
            <div class="col-md-7 text-left">Địa chỉ email: </div>
            <div class="col-md-5 text-left">{{ data.user ? data.user.email : '' }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Mã nhân sự: </div>
            <div class="col-md-7 text-left">{{ data.user_id + 100000 }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Họ và tên: </div>
            <div class="col-md-5 text-left">{{ data.user ? data.user.name : '' }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Vị trí: </div>
            <div class="col-md-5 text-left">{{ data.user && data.user.profile && data.user.profile.account_type ? data.user.profile.account_type.name : '' }} </div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Phòng ban: </div>
            <div class="col-md-5 text-left">{{ data.department_user.department ? data.department_user.department.name : '' }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Ngày tăng ca: </div>
            <div class="col-md-5 text-left">{{ data.start_date |formatDate}}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Giờ bắt đầu: </div>
            <div class="col-md-5 text-left">{{ data.time_checkin }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Giờ kết thúc: </div>
            <div class="col-md-5 text-left">{{ data.time_checkout }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Thời gian bắt đầu tăng ca thực tế: </div>
            <div class="col-md-5 text-left">{{ data.fingerprint_attendance_start }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Thời gian kết thúc tăng ca thực tế: </div>
            <div class="col-md-5 text-left">{{ data.fingerprint_attendance_end }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Lý do tăng ca: </div>
            <div class="col-md-5 text-left">{{ data.reason }} </div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Kết quả tăng ca: </div>
            <div class="col-md-5 text-left">{{ data.overtime_results }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-12 text-left bold">Bạn vui lòng chọn loại tăng ca để xác nhận duyệt đơn của nhân sự. </div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-6 text-left">Loại tăng ca: </div>
            <div class="col-md-6 text-left">
              <el-radio v-model="type_arise" :label="0">Phát sinh giờ làm</el-radio>
              <el-radio v-model="type_arise" :label="1">Phát sinh công việc</el-radio>
            </div>
          </div>
          <div class="col-md-12 d-flex mt-3" v-if="refusal">
            <div class="col-md-6 text-left bold">Nhập lý do từ chối <span class="text-danger">*</span></div>
          </div>
          <div class="col-md-12 d-flex mt-3" v-if="refusal">
            <textarea v-model="reason" class="w-100 rounded" name="" cols="100" rows="10"></textarea>
          </div>
          <p v-if="message" class="col-md-12 text-danger">{{ this.message }}</p>

          <div class="col-md-12 mt-3" v-if="!refusal">
            <p>Chú thích:</p>
            <ul>
              <li>Phát sinh giờ làm: Công việc trong KRA nhưng do tính chất công việc phải làm thêm ngoài giờ hành chính.</li>
              <li>Phát sinh công việc: công việc nằm ngoài: KRA/ MTCV/ KRA công việc khác.</li>
            </ul>
          </div>
          <div class="col-md-12 d-flex justify-content-center mt-3">
            <el-button @click="confirmCancel">Hủy bỏ</el-button>
            <el-button @click="confirm">Xác nhận</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="m-6" v-else-if="data.id">
      <ConfirmPropose
        :data="data"
        :checkPropose="checkPropose"
        :cancel="cancel"
        :publicPath="publicPath"
        :refusal="refusal"
      ></ConfirmPropose>
    </div>
  </div>
</template>

<script>
import ConfirmPropose from "./ConfirmPropose";
export default {
  name: "Overtime",
  components: {
    ConfirmPropose
  },
  data() {
    return {
      type_arise: 0,
      publicPath: process.env.VUE_APP_BASE_URL,
      checkPropose: false,
      cancel: false,
      reason: '',
      message: ''
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    refusal: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  methods: {
    confirm() {
      if (this.refusal && this.reason == '') {
        this.message = 'Lý do từ chối không được để trống';
        return;
      }
      this.checkPropose = true;
      this.$emit('confirm', this.reason, this.type_arise);
      // eslint-disable-next-line vue/no-mutating-props
      this.data.status = 1;
      this.message = '';
    },
    confirmCancel() {
      this.cancel = true;
    }
  }
}
</script>

<style scoped>

</style>